var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 15H24V1.03418H1V15H0V0H25V15ZM11 15H3V12H11V15ZM22 15H14V12H22V15ZM11 11H3V8H11V11ZM22 11H14V8H22V11ZM11 7H3V4H11V7ZM22 7H14V4H22V7Z",
    fill: "#65C988"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseIcon);
export default __webpack_public_path__ + "static/media/warehouse_icon.4ae41d3d56509d1db85879a77debfeba.svg";
export { ForwardRef as ReactComponent };